import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { MatDialog } from '@angular/material';

import { MessageFormComponent } from '../../message-form/message-form.component';

@Component({
  selector: 'app-private-message',
  templateUrl: './private-message.component.html',
  styleUrls: ['./private-message.component.scss'],
  providers: [AngularFireDatabase]
})
export class PrivateMessageComponent implements OnInit {
  @Input() message;
  user : any = {
    avatarUrl: 'https://chispa-rural.firebaseapp.com/assets/img/avatar.png',
  }
  constructor(private db : AngularFireDatabase,
              public dialog : MatDialog,) { }

  ngOnInit() {
    this.db.object('profiles/' + this.message.fromId).snapshotChanges()
      .subscribe(user => {
        this.user.key = user.key;
        Object.assign(this.user, user.payload.val());
      })
  }

  newMessage() {
    let messageDialog = this.dialog.open(MessageFormComponent,  {
      data: {
        user: this.user,
        replyFrom: this.message.key,
      }
    });
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-pm/private-message/private-message.component.ts